export class InputAutocompleteModel {
	value: string = null;
	verified: boolean = false;
	required: boolean = false;
	message: string = '';
	class: string = '';
	color: string = '';
	bgColor: string = 'info';
	data: any = null;
	filterElements: any[] = [];
	total?: any[] = [];

	constructor(value, verified, required, message, classCss, color, bgColor, data, filterElements) {
		this.value = value;
		this.verified = verified;
		this.required = required;
		this.message = message;
		this.class = classCss;
		this.color = color;
		this.bgColor = bgColor;
		this.data = data;
		this.filterElements = filterElements;
	}
}